<div id="auth-screen" [ngClass]="userRole === 'internal' ? 'internal' : 'customer' ">

  @if (stage === 'email') {
    <div class="am-flex-column am-flex-center gap-m width-full bg-white auth-box-wrapper">
      <h2 class="font-icon color-title-grey">Setzen Sie Ihr Passwort zurück</h2>
      <input type="text" [(ngModel)]="email" placeholder="Benutzerkennung eingeben">
      <button class="single-wide-btn green mt-m mb-m" (click)="restorePassword()">Zurücksetzen</button>
      <a class="mta underline text-m color-secondary-grey hover-active" (click)="goBack()">Zurück zum Login</a>
    </div>
  }

  @if (stage === 'token') {
    <div class="am-flex-column am-flex-center gap-m width-full bg-white auth-box-wrapper">
      <span class="color-blue icon icon-ami-user-card"></span>
      <p>Bitte geben Sie die PIN und das neue Passwort ein</p>
      <input type="text" [(ngModel)]="token" placeholder="PIN" autocomplete="new-password">
      <input type="text" [(ngModel)]="password" placeholder="Passwort" autocomplete="new-password">
      <input type="text" [(ngModel)]="password_confirm" placeholder="Passwort bestätigen" autocomplete="new-password">
      <button class="single-wide-btn green" (click)="restorePasswordByToken()">Passwort ändern</button>
      <a class="mta underline text-m color-secondary-grey hover-active" (click)="goBack()">Zurück zum Login</a>
    </div>
  }

</div>
